export default "__VITE_ASSET__BuapWuvr__"